(() => {
  const checkoutModal = document.getElementById('its-kvkk-checkout-gate');
  const whatsappModal = document.getElementById('its-kvkk-whatsapp-modal');

  if (!checkoutModal) return;

  const choices = checkoutModal.querySelector('[data-kvkk-choices]');
  const panels = Array.from(checkoutModal.querySelectorAll('[data-kvkk-panel]'));
  const errorBox = checkoutModal.querySelector('[data-kvkk-error]');
  const registerConsents = Array.from(checkoutModal.querySelectorAll('[data-kvkk-register-consent]'));
  const guestConsent = checkoutModal.querySelector('[data-kvkk-guest-consent]');
  const registerContinue = checkoutModal.querySelector('[data-kvkk-continue="register"]');
  const guestContinue = checkoutModal.querySelector('[data-kvkk-continue="guest"]');
  const customerLoggedIn = checkoutModal.dataset.customerLoggedIn === 'true';

  const state = {
    lastFocused: null,
    pendingProductForm: null,
    pendingProductAdded: false,
    busy: false,
    whatsappUrl: ''
  };

  const rootUrl = () => window.Shopify?.routes?.root || '/';

  const setModalVisibility = (modal, visible) => {
    if (!modal) return;

    if (visible) {
      state.lastFocused = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('its-kvkk-modal-open');
      requestAnimationFrame(() => modal.querySelector('.its-kvkk-modal__dialog')?.focus());
    } else {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');

      if (checkoutModal.hidden && (!whatsappModal || whatsappModal.hidden)) {
        document.documentElement.classList.remove('its-kvkk-modal-open');
      }

      state.lastFocused?.focus?.();
    }
  };

  const clearError = () => {
    if (!errorBox) return;
    errorBox.hidden = true;
    errorBox.textContent = '';
  };

  const showError = (message) => {
    if (!errorBox) return;
    errorBox.textContent = message || 'İşlem sırasında bir hata oluştu. Lütfen tekrar deneyin.';
    errorBox.hidden = false;
  };

  const setButtonBusy = (button, busy) => {
    if (!button) return;
    button.disabled = busy || button.dataset.consentReady === 'false';
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  };

  const resetCheckoutModal = () => {
    choices.hidden = false;
    panels.forEach((panel) => { panel.hidden = true; });
    registerConsents.forEach((input) => { input.checked = false; });
    if (guestConsent) guestConsent.checked = false;
    registerContinue.dataset.consentReady = 'false';
    guestContinue.dataset.consentReady = 'false';
    registerContinue.disabled = true;
    guestContinue.disabled = true;
    clearError();
  };

  const openCheckoutModal = (productForm = null) => {
    state.pendingProductForm = productForm;
    state.pendingProductAdded = false;
    state.busy = false;
    resetCheckoutModal();
    setModalVisibility(checkoutModal, true);
  };

  const closeCheckoutModal = () => {
    if (state.busy) return;
    setModalVisibility(checkoutModal, false);
    state.pendingProductForm = null;
    state.pendingProductAdded = false;
  };

  const selectMode = (mode) => {
    choices.hidden = true;
    panels.forEach((panel) => {
      panel.hidden = panel.dataset.kvkkPanel !== mode;
    });
    clearError();
    checkoutModal.querySelector(`[data-kvkk-panel="${mode}"]`)?.focus?.();
  };

  const validateConsents = () => {
    const registerReady = registerConsents.length > 0 && registerConsents.every((input) => input.checked);
    const guestReady = Boolean(guestConsent?.checked);

    registerContinue.dataset.consentReady = registerReady ? 'true' : 'false';
    guestContinue.dataset.consentReady = guestReady ? 'true' : 'false';
    registerContinue.disabled = !registerReady || state.busy;
    guestContinue.disabled = !guestReady || state.busy;
  };

  const parseResponseError = async (response) => {
    try {
      const data = await response.json();
      return data.description || data.message || data.errors || 'İşlem tamamlanamadı.';
    } catch (_error) {
      return 'İşlem tamamlanamadı.';
    }
  };

  const addPendingProduct = async () => {
    if (!state.pendingProductForm || state.pendingProductAdded) return;

    if (!state.pendingProductForm.checkValidity()) {
      state.pendingProductForm.reportValidity();
      throw new Error('Lütfen ürün seçeneklerini kontrol edin.');
    }

    const formData = new FormData(state.pendingProductForm);
    formData.delete('sections');
    formData.delete('sections_url');
    formData.delete('on_success');

    const response = await fetch(`${rootUrl()}cart/add.js`, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });

    if (!response.ok) {
      throw new Error(await parseResponseError(response));
    }

    state.pendingProductAdded = true;
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  };

  const updateCartAttributes = async (newAttributes) => {
    const cartResponse = await fetch(`${rootUrl()}cart.js`, {
      headers: { Accept: 'application/json' }
    });

    if (!cartResponse.ok) {
      throw new Error('Sepet bilgileri alınamadı.');
    }

    const cart = await cartResponse.json();
    const attributes = { ...(cart.attributes || {}), ...newAttributes };

    const updateResponse = await fetch(`${rootUrl()}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ attributes })
    });

    if (!updateResponse.ok) {
      throw new Error(await parseResponseError(updateResponse));
    }
  };

  const consentAttributes = (mode) => {
    const timestamp = new Date().toISOString();
    const common = {
      'KVKK - İşlem Türü': mode,
      'KVKK - Onay Zamanı': timestamp
    };

    if (mode === 'Üye Ol') {
      return {
        ...common,
        'KVKK - Üyelik Sözleşmesi': 'Onaylandı',
        'KVKK - Üyelik Aydınlatma': 'Onaylandı',
        'KVKK - Ticari İleti Açık Rıza': 'Onaylandı',
        'KVKK - Misafir Aydınlatma': ''
      };
    }

    if (mode === 'Misafir') {
      return {
        ...common,
        'KVKK - Üyelik Sözleşmesi': '',
        'KVKK - Üyelik Aydınlatma': '',
        'KVKK - Ticari İleti Açık Rıza': '',
        'KVKK - Misafir Aydınlatma': 'Onaylandı'
      };
    }

    return {
      ...common,
      'KVKK - Üyelik Sözleşmesi': '',
      'KVKK - Üyelik Aydınlatma': '',
      'KVKK - Ticari İleti Açık Rıza': '',
      'KVKK - Misafir Aydınlatma': ''
    };
  };

  const continueFlow = async (mode, button) => {
    if (state.busy) return;

    if (mode === 'register' && !registerConsents.every((input) => input.checked)) return;
    if (mode === 'guest' && !guestConsent?.checked) return;

    state.busy = true;
    clearError();
    setButtonBusy(button, true);

    try {
      await addPendingProduct();

      if (mode === 'login') {
        await updateCartAttributes(consentAttributes('Giriş Yap'));
        window.location.assign(customerLoggedIn ? checkoutModal.dataset.checkoutUrl : checkoutModal.dataset.loginUrl);
        return;
      }

      if (mode === 'register') {
        await updateCartAttributes(consentAttributes('Üye Ol'));
        window.location.assign(checkoutModal.dataset.registerUrl);
        return;
      }

      await updateCartAttributes(consentAttributes('Misafir'));
      window.location.assign(checkoutModal.dataset.checkoutUrl);
    } catch (error) {
      state.busy = false;
      validateConsents();
      setButtonBusy(button, false);
      showError(error instanceof Error ? error.message : String(error));
    }
  };

  const checkoutSelector = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '[data-kvkk-checkout-trigger]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]',
    'a[href*="/checkout/"]'
  ].join(',');

  document.addEventListener('click', (event) => {
    const buyNowButton = event.target.closest('[data-kvkk-buy-now]');

    if (buyNowButton) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (buyNowButton.disabled || buyNowButton.getAttribute('aria-disabled') === 'true') return;

      const formId = buyNowButton.dataset.formId;
      const productForm = (formId && document.getElementById(formId)) || buyNowButton.closest('form');

      if (!productForm) {
        showError('Ürün formu bulunamadı. Lütfen sayfayı yenileyip tekrar deneyin.');
        return;
      }

      if (!productForm.checkValidity()) {
        productForm.reportValidity();
        return;
      }

      openCheckoutModal(productForm);
      return;
    }

    const checkoutTrigger = event.target.closest(checkoutSelector);

    if (checkoutTrigger && !checkoutTrigger.closest('#its-kvkk-checkout-gate')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openCheckoutModal();
      return;
    }

    const modeButton = event.target.closest('[data-kvkk-mode]');
    if (modeButton) {
      selectMode(modeButton.dataset.kvkkMode);
      return;
    }

    const backButton = event.target.closest('[data-kvkk-back]');
    if (backButton) {
      resetCheckoutModal();
      return;
    }

    const continueButton = event.target.closest('[data-kvkk-continue]');
    if (continueButton) {
      continueFlow(continueButton.dataset.kvkkContinue, continueButton);
      return;
    }

    if (event.target.closest('[data-kvkk-close]')) {
      closeCheckoutModal();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    const isCheckoutSubmit = submitter?.name === 'checkout' || submitter?.matches?.('[data-kvkk-checkout-trigger]');

    if (isCheckoutSubmit && !event.target.closest('#its-kvkk-checkout-gate')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openCheckoutModal();
    }
  }, true);

  registerConsents.forEach((input) => input.addEventListener('change', validateConsents));
  guestConsent?.addEventListener('change', validateConsents);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    if (!checkoutModal.hidden) {
      closeCheckoutModal();
    } else if (whatsappModal && !whatsappModal.hidden) {
      setModalVisibility(whatsappModal, false);
    }
  });

  if (whatsappModal) {
    const whatsappConsent = whatsappModal.querySelector('[data-kvkk-whatsapp-consent]');
    const whatsappContinue = whatsappModal.querySelector('[data-kvkk-whatsapp-continue]');

    const openWhatsappModal = (url) => {
      state.whatsappUrl = url;
      whatsappConsent.checked = false;
      whatsappContinue.disabled = true;
      setModalVisibility(whatsappModal, true);
    };

    document.addEventListener('click', (event) => {
      const explicitTrigger = event.target.closest('[data-kvkk-whatsapp-trigger]');
      const whatsappLink = event.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"], a[href*="whatsapp.com/send"]');
      const trigger = explicitTrigger || whatsappLink;

      if (trigger && !trigger.closest('#its-kvkk-whatsapp-modal')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openWhatsappModal(trigger.dataset.whatsappUrl || trigger.href);
        return;
      }

      if (event.target.closest('[data-kvkk-whatsapp-close]')) {
        setModalVisibility(whatsappModal, false);
        return;
      }

      if (event.target.closest('[data-kvkk-whatsapp-continue]') && whatsappConsent.checked && state.whatsappUrl) {
        const destination = state.whatsappUrl;
        setModalVisibility(whatsappModal, false);
        window.open(destination, '_blank', 'noopener,noreferrer');
      }
    }, true);

    whatsappConsent.addEventListener('change', () => {
      whatsappContinue.disabled = !whatsappConsent.checked;
    });
  }
})();
